<template>
  <SAISelect
    v-bind="$attrs"
    v-on="$listeners"
    :value="value"
    :options="searchOptions"
    :option-label="optionLabel"
    :option-value="optionValue"
    :disable="requiredDisable"
    @filter="filterFn"
  />
</template>

<script>
import { SAISelect } from 'ecx.saigon.ui.common';

export default {
  name: 'ColourAndExtraSelect',
  props: {
    value: undefined,
    disable: Boolean,
    precluded: {
      type: Object,
      default: () => ({})
    },
    allRequired: {
      type: Object,
      default: () => ({})
    },
    optionLabel: {
      type: String,
      default: 'name'
    },
    optionValue: {
      type: String,
      default: 'id'
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchOptions: []
    };
  },
  computed: {
    filteredOptions() {
      return this.options.filter((option) => {
        return !this.precluded[option.id];
      });
    },
    requiredDisable() {
      const id = this.value ? this.value.id : undefined;
      return Boolean(this.allRequired[id]) || this.disable;
    }
  },
  methods: {
    filterFn(value, update) {
      update(() => {
        this.searchOptions = this.filteredOptions.filter((option) => {
          return (
            option.name.toLocaleLowerCase().indexOf(value.toLowerCase()) > -1
          );
        });
      });
    }
  },
  components: {
    SAISelect
  }
};
</script>
